export default async function getReviews(count) {
    const url = '/reviews.json';

    let json;
    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        json = await response.json();
    } catch (error) {
        return [
            {
                id: 0,
                text: ''
            }
        ];
    }

    if (count > json.length) {
        throw new Error(
            'Number of items requested exceeds the JSON length'
        );
    }

    const shuffledJson = json.sort(() => 0.5 - Math.random());
    return shuffledJson.slice(0, count);
}
